import React from 'react';
import { IconProps } from '../types/types';

const NEO: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333.1 368.5" role="img" {...props}><g data-name="Layer 2"><g data-name="Layer 1"><g data-name="Layer 2"><g data-name="Layer 1-2"><path style={{fill: '#00e599'}} d="M0 64.6v246.5l160 57.4V120l173.1-63.8L176 0 0 64.6z"/><path style={{fill: '#00af92'}} d="M173.1 127.1v134.8l160 57.4V67.9l-160 59.2z"/></g></g></g></g></svg>
);

export default NEO;
